import {Component, Inject, Input, OnInit} from '@angular/core';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar, MatTableDataSource} from '@angular/material';
import {ConfService} from '../../conf.service';
import {AddPlatformConsoleConfigurationComponent} from '../platform-console/platform-console.component';

@Component({
  selector: 'app-file-storage-configs',
  templateUrl: './file-storage-configs.component.html',
  styleUrls: ['./file-storage-configs.component.scss']
})
export class FileStorageConfigsComponent implements OnInit {

  @Input() data: any;
  @Input() totalServices: any;
  @Input() settingsData: any;
  @Input() selectedEnvironment: any;

  selectedElement: any;
  dataSource: any;

  selectable = true;
  removable = true;
  addOnBlur = true;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  displayedColumns = ['Selection', 'Name', 'URL', 'Provider', 'Cloud', 'Primary Region', 'Regions', 'Status', 'Add'];


  constructor(public platform: LeftpanelComponent, private snackBar: MatSnackBar, private dialog: MatDialog, private confPost: ConfService) { }

  editToggle(i) {
    this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
  }

  editConfiguration(i) {
    if (this.totalServices) {
      this.dataSource['data'][i]['isEdit'] = !this.dataSource['data'][i]['isEdit'];
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }
      const temp = this.totalServices.filter((service) => service.name === 'Storage');
      if (temp && temp.length > 0) {
        temp[0]['configurations'][i] = this.dataSource['data'][i];
      }
      this.data['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }
      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.settingsData['id'], this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration updated successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize();
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while updating configuration.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  removeConfiguration(i) {
    if (this.totalServices) {
      const temp = this.totalServices.filter((service) => service.name === 'Storage');
      if (temp && temp.length > 0) {
        if (temp[0]['configurations'][i]['is_default'] !== true) {
          if (confirm('This action is irreversible. Are you sure want to remove this configuration?')) {
            for (const val of this.dataSource.data) {
              delete val['isEdit'];
            }
            temp[0]['configurations'].splice(i, 1);
            this.data['configurations'] = temp[0]['configurations'];
            const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
            if (temp1 && temp1.length > 0) {
              temp1[0]['services'] = this.totalServices;
            }

            const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
              width: 'auto',
              height: 'auto',
            });

            this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.settingsData['id'], this.settingsData).subscribe(resp => {
              if (resp) {
                this.snackBar.open( 'Configuration deleted successfully', 'Success', {
                  duration: 5000,
                  verticalPosition: 'top',
                  horizontalPosition: 'center'
                });
                this.initialize();
              }
              loaderDialog.close();
            }, error => {
              this.snackBar.open( 'Error while deleting the configuration.', 'Error', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              loaderDialog.close();
            });
          }
        } else {
          this.snackBar.open('Default configuration cannot be deleted.', 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    }
  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  ngOnInit() {
    this.initialize();
  }

  initialize() {
    this.dataSource = new MatTableDataSource([]);
    for (const val of this.data['configurations']) {
      val['isEdit'] = false;
      if (val.is_default === true) {
        this.selectedElement = val;
      }
    }
    this.dataSource.data = this.data['configurations'];
  }

  changeDefault(event, index) {
    const temp = this.totalServices.filter((service) => service.name === 'Storage');
    if (temp && temp.length > 0) {
      for (const val of this.dataSource.data) {
        delete val['isEdit'];
      }

      for (const config of temp[0]['configurations']) {
        config['is_default'] = false;
      }

      temp[0]['configurations'][index]['is_default'] = true;

      this.data['configurations'] = temp[0]['configurations'];
      const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
      if (temp1 && temp1.length > 0) {
        temp1[0]['services'] = this.totalServices;
      }

      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        width: 'auto',
        height: 'auto',
      });

      this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.settingsData['id'], this.settingsData).subscribe(resp => {
        if (resp) {
          this.snackBar.open( 'Configuration made default successfully', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.initialize();
        }
        loaderDialog.close();
      }, error => {
        this.snackBar.open( 'Error while making the configuration default', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        loaderDialog.close();
      });
    }
  }

  addConfiguration() {
    const addConfigurationDialog = this.dialog.open(AddFileStorageConfigurationComponent, {
      width: '60vw',
      height: 'auto',
      data: {
        configuration: {
          regions: [],
          name: '',
          url: '',
          provider: '',
          status: '',
          is_default: false,
          cloud: '',
          primary_region: '',
          verification_status: 'created',
          audit_logs: [
            {
              action: 'CREATE',
              by: localStorage.getItem('primary_email'),
              at: Date.now()
            }
          ],
        },
        isEdit: false
      }
    });

    addConfigurationDialog.afterClosed().subscribe(response => {
      if (response) {
        if (this.totalServices) {
          for (const val of this.dataSource.data) {
            delete val['isEdit'];
          }
          const temp = this.totalServices.filter((service) => service.name === 'Storage');
          if (temp && temp.length > 0) {
            temp[0]['configurations'].push(response);
          }
          this.data['configurations'] = temp[0]['configurations'];
          const temp1 = this.settingsData['environments'].filter((env) => env['name'] === this.selectedEnvironment['name']);
          if (temp1 && temp1.length > 0) {
            temp1[0]['services'] = this.totalServices;
          }

          const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            width: 'auto',
            height: 'auto',
          });

          this.confPost.patchEntityData('services', 'services', 'v2', 'settings', this.settingsData['id'], this.settingsData).subscribe(resp => {
            if (resp) {
              this.snackBar.open( 'Configuration added successfully', 'Success', {
                duration: 5000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
              });
              this.initialize();
            }
            loaderDialog.close();
          }, error => {
            this.snackBar.open( 'Error while adding the configuration.', 'Error', {
              duration: 5000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            loaderDialog.close();
          });
        }
      }
    });
  }

}

@Component({
  selector: 'add-file-storage-configuration',
  templateUrl: 'add-file-storage-configuration.component.html',
  styleUrls: ['add-file-storage-configuration.component.css']
})
export class AddFileStorageConfigurationComponent implements OnInit {

  selectable = true;
  removable = true;
  addOnBlur = true;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<AddFileStorageConfigurationComponent>, private snackBar: MatSnackBar) {
    dialogRef.disableClose = true;

  }

  ngOnInit() {

  }

  add(event, data): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      data.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(val, data): void {
    const index = data.indexOf(val);

    if (index >= 0) {
      data.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close();
  }

  addConfiguration() {
    if (this.data['configuration']['name'] !== '' && this.data['configuration']['provider'] !== '' && this.data['configuration']['url'] !== '' && this.data['configuration']['cloud'] !== '' &&
        this.data['configuration']['primary_region'] !== '' && this.data['configuration']['regions'].length > 0) {
      this.dialogRef.close(this.data['configuration']);
    } else {
      this.snackBar.open('Please provide all the required values', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

}
